import { renderToStaticMarkup } from 'react-dom/server';
import _ from 'lodash';
import { LanguageType, DefaultLanguageKeys } from '../Language';
import englishErrors from './en/errors.json';
import englishFields from './en/fields.json';
import englishPages from './en/pages.json';
const protectedTranslationKeys = ['description'];
const getTranslationsData = (pagesTranslations, fieldsTranslations, errorsTranslations) => {
    return {
        errors: formatTranslationsData(errorsTranslations, DefaultLanguageKeys.Error),
        fields: formatTranslationsData(fieldsTranslations, DefaultLanguageKeys.Label),
        pages: formatTranslationsData(pagesTranslations, DefaultLanguageKeys.Text),
    };
};
const formatTranslationsData = (data, expandedKey) => {
    return _.reduce(data, (acc, val, key) => {
        if (key === expandedKey || _.includes(protectedTranslationKeys, key)) {
            acc[key] = val;
        }
        else if (_.isString(val)) {
            acc[key] = { [expandedKey]: val };
        }
        else {
            // recurse
            acc[key] = formatTranslationsData(val, expandedKey);
        }
        return acc;
    }, {});
};
const en = getTranslationsData(englishPages, englishFields, englishErrors);
export const AllLanguageTypes = [LanguageType.English, LanguageType.Spanish, LanguageType.Chinese];
export const allTranslations = {
    en,
    es: en,
    zh: en,
};
export const getLocalizeOptions = (languageTypes) => {
    const languageNamesByKey = _.reduce(_.mapValues(LanguageType, l => l), (acc, l, n) => {
        acc[l] = n;
        return acc;
    }, {});
    return {
        languages: _.map(languageTypes, (code) => ({
            code,
            name: languageNamesByKey[code],
        })),
        options: {
            renderInnerHtml: true,
            renderToStaticMarkup,
        },
    };
};
//# sourceMappingURL=index.js.map